import {
  AppBar,
  Box,
  Button,
  ButtonGroup,
  Grid,
  Toolbar,
  Typography,
} from '@material-ui/core';
import moment from 'moment';
import { ToastContainer, toast } from 'react-toastify';
import WeeklyTime from './WeeklyTime/WeeklyTime';
import WeekPicker from './WeekPicker/index';
import AddIcon from '@material-ui/icons/Add';
import { makeStyles } from '@material-ui/styles';
import { ToggleButtonGroup, ToggleButton } from '@material-ui/lab';
import routes from '../../../Utils/routes.json';
import { useHistory, useLocation } from 'react-router-dom';
import BreadCrumb from '../../../Components/BreadCrumb';
import KenCard from '../../../global_components/KenCard';
import ControlledTreeView from '../../../Components/KenCheckBoxTree';
import Calendar from './Calendar';
import React, { useEffect, useState } from 'react';
import KenDateTimePicker from '../../../global_components/KenDateTimePicker';
import resourcesData from './data/resources.json';
import resourcesDataSecond from './data/resourcesSecond.json';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

// Initially Fetch events(eventsData) from API, on DnD use `allEventData` object to send updated event list to backend server
import { eventsData } from './data/events';
import { eventsDataSecond } from './data/eventSecond';

import treeItemData from './data/treeItem.json';
import timeData from './data/time.json';

import treeItemDataSecond from './data/treeItem2.json';
import { RiFilterLine } from 'react-icons/ri';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import KenSelectWrap from '../../../global_components/KenSelect';
import KenSelect from '../../../global_components/KenSelect';
import KenLoader from '../../../Components/KenLoader/index';
import { Today } from '@material-ui/icons';
import { getAcademicFilter } from '../../../Utils/apiServices';
const TODAY = moment().format('YYYY-MM-DD');

const useToggleStyles = makeStyles((theme) => ({
  root: {
    '&&': {
      display: 'inline-flex',
      color: theme.palette.KenColors.primary,
      backgroundColor: theme.palette.KenColors.kenWhite,
      boxShadow:
        '0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)',
      '&:hover': {
        boxShadow: 'none',
      },
    },
  },
  selected: {
    '&&': {
      backgroundColor: theme.palette.KenColors.primary,
      color: theme.palette.KenColors.kenWhite,
      '&:hover': {
        backgroundColor: theme.palette.KenColors.primary,
        color: theme.palette.KenColors.kenWhite,
        boxShadow: 'none',
      },
    },
  },
}));

const useStyles = makeStyles((theme) => ({
  breadCrumbWrapper: {
    margin: '15px 0',
  },
  header: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
  },
  headerRight: {
    display: 'flex',
    justifyContent: 'end',
  },
  title: {
    fontSize: 18,
    fontWeight: 600,
  },
  calenderSidebar: {
    margin: '0',
    padding: '0',
  },
  pageActions: {
    display: 'flex',
    flexDirection: 'row-reverse',
    margin: '10px 0',
  },
  actionBtn: {
    margin: '0 10px',
  },
  kenDateTimePickerColor: {
    top: '-1px',
  },
}));

const arrayBreadCrumb = [
  { head: 'HOME', url: routes.academicsPlanner },
  {
    head: 'TIME TABLE',
  },
];

const selectOptions = [
  {
    label: 'Today',
    value: 'today',
  },
];
const weekOptions = [
  {
    label: 'Week',
    value: 'week',
  },
];

const TimeTable = () => {
  console.log('In time table');
  const history = useHistory();
  const classes = useStyles();
  const toggleClasses = useToggleStyles();

  const [treeItems, setTreeItems] = useState([]);
  //events and setEvents is for rendering and filter event-data using checkbox
  const [events, setEvents] = useState([]);
  const [resources, setResources] = useState([]);

  const [expanded, setExpanded] = useState(['2']);
  const [dateToViewTT, setDateToViewTT] = useState(new Date());

  const [selected, setSelected] = useState(['202']);
  const [toogleButton, setToogleButton] = useState(true);
  const [calendarDay, setCalendarDay] = useState(TODAY);
  const [weekDay, setWeekDay] = useState(TODAY);
  const [calendarMode, setCalendarMode] = useState('facility'); // {'facility', 'faculty'}
  const [calendarView, setCalendarView] = useState('week'); // 'week' -> Weekly, 'month' -> Monthly
  const [selectValue, setSelectValue] = useState(selectOptions[0].value);
  const [selectWeekValue, setWeekSelectValue] = useState(weekOptions[0].value);

  const [fromDate, setfromDate] = useState(new Date());
  const [toDate, settoDate] = useState(new Date());
  const [currentWeek, setCurrentWeek] = useState([]);

  const location = useLocation();
  const [selectedAcademicProgram, setSelectedAcademicProgram] = useState();
  const [programID, setProgramID] = useState('');
  const [termDropdown, setTermDropdown] = useState([]);
  const [term, setTerm] = useState();
  const [courseOptions, setCourseOptions] = React.useState([]);
  const [filters, setFilters] = useState({});
  const [locationData, setLocationData] = useState();
  const [loading, setLoading] = React.useState(false);
  const [campusOptions, setCampusOptions] = React.useState([]);
  const [programName, setProgramName] = useState(
    location?.state?.programName || sessionStorage.getItem('programName')
  );
  const [intake, setIntake] = useState(
    location?.state?.intake || sessionStorage.getItem('intake')
  );
  const [year, setYear] = useState(
    location?.state?.year || sessionStorage.getItem('year')
  );
  const yearOptions = [
    { label: '2015', value: '2015' },
    { label: '2016', value: '2016' },
    { label: '2017', value: '2017' },
    { label: '2018', value: '2018' },
    { label: '2019', value: '2019' },
    { label: '2020', value: '2020' },
    { label: '2021', value: '2021' },
    { label: '2022', value: '2022' },
    { label: '2023', value: '2023' },
    { label: '2024', value: '2024' },
    { label: '2025', value: '2025' },
    { label: '2026', value: '2026' },
    { label: '2027', value: '2027' },
    { label: '2028', value: '2028' },
    { label: '2029', value: '2029' },
    { label: '2030', value: '2030' },
    { label: '2031', value: '2031' },
    { label: '2032', value: '2032' },
    { label: '2033', value: '2033' },
    { label: '2034', value: '2034' },
    { label: '2035', value: '2035' },
    { label: '2036', value: '2036' },
    { label: '2037', value: '2037' },
    { label: '2038', value: '2038' },
    { label: '2039', value: '2039' },
    { label: '2040', value: '2040' },
  ];
  const intakeOptions = [
    { label: 'JAN', value: 'JAN' },
    { label: 'FEB', value: 'FEB' },
    { label: 'MAR', value: 'MAR' },
    { label: 'APR', value: 'APR' },
    { label: 'MAY', value: 'MAY' },
    { label: 'JUN', value: 'JUN' },
    { label: 'JUL', value: 'JUL' },
    { label: 'AUG', value: 'AUG' },
    { label: 'SEP', value: 'SEP' },
    { label: 'OCT', value: 'OCT' },
    { label: 'NOV', value: 'NOV' },
    { label: 'DEC', value: 'DEC' },
  ];

  /**
   * allEventData is for update event-list after drag and drop
   * The reason to use another object(allEventData) instead of "events" is that React is not allow us to update state of events after DnD*/
  const [allEventData, setAllEventData] = useState([]);
  // console.log('allEventData', allEventData);
  const handleDateChange = (date) => {
    setDateToViewTT(new Date(date));
  };
  const changeWeek = (op) => {
    let newWeekStart;
    if (op === 'next') {
      let endOfWeek = moment(dateToViewTT).endOf('week').toDate();
      newWeekStart = moment(endOfWeek).add(2, 'days');
    } else {
      let startOfWeek = moment(dateToViewTT).startOf('week').toDate();
      newWeekStart = moment(startOfWeek).subtract(2, 'days');
    }
    setDateToViewTT(new Date(newWeekStart));
  };
  React.useEffect(() => {
    setLoading(true);
    let locationData = history?.location?.state?.batchName;
    setLocationData(locationData);
    getAcademicFilter()
      .then((res) => {
        let courseOptions = [];
        let campusOptions = [];
        Object.entries(res['Academic Program']).map(([item, keyVal]) => {
          courseOptions.push({
            label: item,
            value: item,
            id: keyVal.id,
            terms: JSON.parse(keyVal.terms),
          });
        });
        Object.entries(res['Campus']).map(([item, keyVal]) => {
          campusOptions.push({ label: item, value: item });
        });
        setCourseOptions(courseOptions);
        setCampusOptions(campusOptions);
        if (locationData != undefined) {
          setProgramName(locationData);
          let e = { target: { name: 'program', value: locationData } };
          handleFilter(e, courseOptions);
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    if (toogleButton === true) {
      setTreeItems(treeItemData);
      setResources(resourcesData);
      setAllEventData(eventsData);
    } else {
      setTreeItems(treeItemDataSecond);
      setResources(resourcesDataSecond);
      setAllEventData(eventsDataSecond);
    }
  }, [toogleButton, allEventData]);

  useEffect(() => {
    if (toogleButton === true) {
      const todayEvents = eventsData.filter(
        (event) =>
          moment(calendarDay).startOf('day') <= moment(event.start) &&
          moment(event.end) < moment(calendarDay).endOf('day')
      );

      let selectedEvents = [];
      for (const key of selected) {
        let temp = todayEvents.filter((event) => event.treeItemId === key);
        selectedEvents.push(...temp);
      }

      setEvents(selectedEvents);
    } else {
      const todayEvents = eventsDataSecond.filter(
        (event) =>
          moment(calendarDay).startOf('day') <= moment(event.start) &&
          moment(event.end) < moment(calendarDay).endOf('day')
      );

      let selectedEvents = [];
      for (const key of selected) {
        let temp = todayEvents.filter((event) => event.treeItemId === key);
        selectedEvents.push(...temp);
      }

      setEvents(selectedEvents);
    }
  }, [calendarDay, selected, toogleButton]);

  const handleToggle = (event, nodeIds) => {
    if (event.target.nodeName !== 'svg') {
      return;
    }

    setExpanded(nodeIds);
  };

  const handleSelect = (event, nodeIds) => {
    if (event.target.nodeName === 'svg') {
      return;
    }
    const first = nodeIds[0];
    if (selected.includes(first)) {
      setSelected(selected.filter((id) => id !== first));
    } else {
      setSelected([first, ...selected]);
    }
  };
  const handleFilter = (e, data) => {
    const { name, value } = e.target;
    setFilters({
      ...filters,
      [name]: value,
    });
    if (e.target.name === 'program') {
      setProgramName(value);
      let newData = data.filter((element) => {
        return element.label === e.target.value;
      });
      let termData = [];
      newData[0]?.terms.map((item) => {
        termData.push({ label: item.name, value: item.name });
      });
      termData.push({ label: 'All', value: 'All' });
      setSelectedAcademicProgram(newData);
      setProgramID(newData[0]?.id);
      setTermDropdown(termData);
      setTerm(undefined);
    } else if (e.target.name === 'intake') {
      setIntake(value);
    }
  };
  const handleCalendarMode = (event, nextView) => {
    setCalendarMode(nextView);
  };

  const handlePrevDay = () => {
    const nextCalendarDay = moment(calendarDay)
      .subtract(1, 'day')
      .format('YYYY-MM-DD');
    setCalendarDay(nextCalendarDay);
  };

  const handleCurrentDay = (e) => {
    setCalendarDay(e.target.value);
  };
  function getCurrentWeek(selectedDate) {
    let weekStart = moment(selectedDate).clone().startOf('isoWeek');
    let days = [];

    for (var i = 0; i <= 6; i++) {
      days.push({
        date: moment(weekStart).add(i, 'days').format('DD/MM/YYYY'),
        day: moment(weekStart).add(i, 'days').format('dddd'),
      });
    }
    return days;
  }

  useEffect(() => {
    let weekDates = [];
    if (dateToViewTT) {
      weekDates = getCurrentWeek(dateToViewTT);
    }
    setCurrentWeek(weekDates);
  }, [dateToViewTT]);
  console.log('currentWeek', currentWeek);
  useEffect(() => {
    currentWeek.map(() => {});
  }, [currentWeek]);

  const handleNextDay = () => {
    const nextCalendarDay = moment(calendarDay)
      .add(1, 'day')
      .format('YYYY-MM-DD');
    setCalendarDay(nextCalendarDay);
  };

  const handleSelectWeekChange = (e) => {
    setWeekSelectValue(e.target.value);
  };
  const handleSelectChange = (e) => {
    console.log('eeeeeeeeeeeeeeee');
    setSelectValue(e.target.value);
  };

  return (
    <Box>
      {loading && <KenLoader />}
      <Box className={classes.breadCrumbWrapper}>
        {/* <BreadCrumb array={arrayBreadCrumb} history={history} /> */}
      </Box>

      <AppBar position="static" elevation={0} className={classes.header}>
        <Toolbar>
          <Grid container>
            <Grid item xs={6} className={classes.headerLeft}>
              <Typography variant="h6" className={classes.title}>
                Time Table
              </Typography>
            </Grid>
            <Grid item xs={6} style={{textAlign: 'right'}}>
              <Button
                className={classes.filterButton}
                variant="contained"
                color="primary"
                onClick={() => {
                  history.push({
                    pathname: `${routes.fullCalendar}`,
                    state: {
                      programName: programName,
                      intake: intake,
                      year: year,
                      batchName: locationData,
                      id: programID,
                    },
                  });
                }}
              >
                Edit
              </Button>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>

      <Box className={classes.pageActions}></Box>
      <Grid container spacing={2} style={{ marginBottom: '10px' }}>
        <Grid xs={2} style={{ margin: '0px 10px' }}>
          <KenSelect
            name="program"
            label="Academic Program *"
            options={courseOptions}
            value={programName}
            dropdownColor="#ffffff"
            onChange={(el) => handleFilter(el, courseOptions)}
            required={true}
          />
        </Grid>
        <Grid xs={2} style={{ marginRight: '10px' }}>
          <KenSelect
            label="Year *"
            options={yearOptions}
            value={year}
            dropdownColor="#ffffff"
            onChange={(e) => setYear(e.target.value)}
            required={true}
          />
        </Grid>
        <Grid xs={2} style={{ marginRight: '10px' }}>
          <KenSelectWrap
            name="intake"
            label="Intake *"
            options={intakeOptions}
            value={intake}
            dropdownColor="#FFFFFF"
            onChange={(el) => handleFilter(el, intakeOptions)}
            required
          />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} md={2}>
          <KenSelectWrap
            options={selectOptions}
            value={selectValue}
            dropdowncolor="#FFFFFF"
            onChange={handleSelectChange}
            required
          />
        </Grid>

        <Grid
          item
          xs={12}
          md={8}
          style={{ display: 'flex', justifyContent: 'center' }}
        >
          <div style={{ width: '300px', display: 'flex' }}>
            <ArrowBackIcon
              className={classes.arrow}
              size="small"
              onClick={() => changeWeek('prev')}
            ></ArrowBackIcon>
            <WeekPicker
              value={dateToViewTT}
              onChange={handleDateChange}
              selector={calendarView}
              inputSize={calendarView === 'week' ? 10 : 40}
              inputBaseMinWidth={calendarView === 'week' ? '150px' : '260px'}
            />
            <ArrowForwardIcon
              className={classes.arrow}
              size="small"
              onClick={() => changeWeek('next')}
            ></ArrowForwardIcon>
          </div>
        </Grid>

        <Grid
          item
          xs={12}
          md={2}
          style={{ display: 'flex', justifyContent: 'flex-end' }}
        >
          <Grid item xs={12} md={12}>
            <KenSelectWrap
              options={weekOptions}
              value={selectWeekValue}
              dropdowncolor="#FFFFFF"
              onChange={handleSelectWeekChange}
              required
            />
          </Grid>
        </Grid>
      </Grid>

      <KenCard className={classes.calenderSidebar} elevation={0}>
        <Grid container spacing={3}>
          <WeeklyTime />
        </Grid>
        <ToastContainer />
      </KenCard>
    </Box>
  );
};

export default TimeTable;
